enum STATUS {
	PENDING = 'Pending',
	ENROLLED = 'Enrolled',
	COMPLETED = 'Completed',
	DECLINED = 'Declined',
	SUSPENDED = 'Suspended',
}

export default STATUS;
